import { QueryClient } from '@tanstack/react-query';
import { feedback } from '../alertService';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: async (err: unknown) => {
        feedback(String(err), 'error');
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 30_000,
      cacheTime: 300_000,
    },
    mutations: {
      onError: async (err: unknown) => {
        feedback(String(err), 'error');
      },
    },
  },
});
